import LRUCache from "lru-cache"

let redis = {}
let redisOffline = {}

if (typeof window === "undefined" && !process.env.IS_DOCKER_BUILD) {
  const Client = require("ioredis")
  const { readOfflineData } = require("./offline")

  const credentials = {
    port: process.env.REDIS_PORT,
    host: process.env.REDIS_HOST,
    username: process.env.REDIS_USERNAME,
    password: process.env.REDIS_PASSWORD,
    keyPrefix: process.env.REDIS_PREFIX,
    db: 0,
  }

  const readIsOffline = async () => {
    try {
      const { readOfflineData: read } = require("./offline")
      const data = await read()
      return data.isOffline || false
    } catch (error) {
      console.error("Error reading offline status in cache:", error)
      return false
    }
  }

  redisOffline = new Client({ ...credentials, db: 1 })
  redis = new Client({ ...credentials, db: 0 })

  redis = new Proxy(redis, {
    get(target, prop, receiver) {
      if (prop === "set") {
        return function (...args) {
          Reflect.apply(target[prop], this, args)
          redisOffline.set(args[0], args[1])
        }
      }
      return Reflect.get(target, prop, receiver)
    },
  })

  redis = new Proxy(redis, {
    get(target, prop, receiver) {
      if (prop === "get") {
        return async function (...args) {
          const isOffline = await readIsOffline()
          if (isOffline) return redisOffline.get(args[0])
          return Reflect.apply(target[prop], this, args)
        }
      }
      return Reflect.get(target, prop, receiver)
    },
  })
}

export { redis, redisOffline }

export const lruCache = new LRUCache({
  max: 100,
  ttl: 1000 * 60 * 60,
})
